import DialogInOne from "src/components/DialogInOne";
import { useDialogProviderContext } from "src/features/DialogProvider";
import Content from "./content";
import { Button } from "src/components/MuiGenerals";
import { useTranslation } from "src/hooks";
import { MultisigDisplayData } from "./types";

function MultisigDialog({
  data,
  refetchFn,
}: {
  data: MultisigDisplayData;
  refetchFn: () => Promise<void>;
}) {
  const { isOpen, setIsOpen } = useDialogProviderContext();
  const { t, tc } = useTranslation("assetManagement");

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <DialogInOne
      title={t("multisig")}
      self={{
        open: isOpen,
        onClose,
      }}
      content={<Content data={data} refetchFn={refetchFn} />}
      onConfirm={() => {}}
      isConfirmHidden
      onCancel={onClose}
      isCancelHidden
      actionButtons={
        <div style={{ padding: 8 }}>
          <Button
            color={"error"}
            variant={"contained"}
            children={tc("close")}
            onClick={onClose}
          />
        </div>
      }
      maxWidth="md"
    />
  );
}

export default MultisigDialog;
